const langData = {
  en: {
    confirm_new_password: 'Confirm New Password',
    modal_header: 'Beware of Employee Recruitment Fraud',
    modal_desc:
      'does not charge any fees during the recruitment process. Avoid scams by carefully examining emails and websites used for job postings. We are not responsible for any job posting scams that use the Sopra Group name.',
    modal_desc_2:
      'To verify job postings at SOPRA, contact us via email at recruitment01@solusi-pack.com or visit our official website at: portal.solusi-pack.com',
    home_title1: 'Find your',
    home_title2: 'place',
    at: 'at',
    life_at: 'Life at',
    navigation: 'Navigation',
    lets_connect: "Let's Connect",
    life_at_sopra: 'Life at SOPRA',
    how_we_hire: 'How We Hire',
    build_your: 'Build your',
    career: 'career',
    teams: 'Teams',
    blogs: 'Blogs',
    faq: 'FAQ',
    still: 'Still',
    curious: 'curious',
    explore_jobs: 'Explore Jobs',
    intro_desc_1:
      'At SOPRA , everyone has the chance to shine. We encourage bold ideas, support one another, and celebrate achievements. Here, every idea matters more than titles. With an open and supportive culture, we face challenges together and create impactful solutions. We can’t wait to invite you to join us and be part of this journey.',
    intro_title_2: 'Unlock Your Potential',
    intro_desc_2:
      'We believe that growth begins on day one. From the moment you join, you’ll be trusted with meaningful projects that expand your skills, strengthen your confidence, and accelerate your journey. Here, we give you opportunities to unlock the best version of yourself.',
    intro_title_3: 'Meet Our Director',
    intro_desc_3:
      'We don’t just deliver packaging solutions, we deliver the future. At SOPRA, every project is a chance to innovate, every partnership an opportunity to inspire, and every step forward a commitment to excellence. Our ambition is clear: to innovate, to set new standards for the industry, and to leave a mark that truly matters. This is possible because we believe in thinking big and moving with purpose. Now, we are looking for people who share that same passion. Individuals who are curious, courageous, driven by innovation, committed to improvement, and determined to make a real difference.',
    intro_subDesc_3:
      'The future is exciting, and we can’t wait to invite you to be part of it.',
    testimony_title_1: 'Lukito - Production Assistant Manager',
    testimony_desc_1:
      'Before joining SOPRA Group, I was working as an Extruder Supervisor with skills mainly in production processes and only a little knowledge of electrical. Since becoming part of SOPRA Group, my capabilities have grown significantly both in process and technical areas such as electrical, mechanical, and utility. What I value the most is the scholarship opportunity that allowed me to pursue a four-year degree and earn my Bachelor of Engineering. Thank You SOPRA',
    testimony_title_2: 'Koko Santoso - Human Capital Assistant Manager',
    testimony_desc_2:
      'Working at SOPRA Group has been a journey full of challenges, yet truly exciting. The company’s culture is unique and inspiring, with people who are always open to collaborate and support one another. What I appreciate the most is how SOPRA encourages innovation and gives us the freedom to explore new ideas. This environment not only pushes me to grow professionally but also makes every day at work engaging and meaningful.',
    testimony_title_3: 'Ergha Thoriq - Sales Executive',
    testimony_desc_3:
      'From HR to supervisors, everyone gave me a warm welcome and guided me in a friendly way. With colleagues who are always supportive, the work atmosphere at SOPRA feels like family while still remaining professional.',
    testimony_title_4: 'Alvix Robby - General Affairs & HSE Supervisor',
    testimony_desc_4:
      'Working at SOPRA Group has been a truly enjoyable and rewarding experience. Every day feels exciting because the environment is dynamic, the challenges are real, and there are always new things to learn. What I enjoy the most is the strong teamwork my colleagues make the workplace fun and collaborative, while my supervisors provide great support and guidance that help me grow both personally and professionally.',
    testimony_title_5: 'Naseh Hudin – Production Supervisor',
    testimony_desc_5:
      'During my time at PT SOPRA, I’ve experienced a work environment that is both professional and supportive of personal growth. I’ve gained valuable knowledge and experiences along the way. For me, working at PT SOPRA is not just about the job, but also about the sense of family built with colleagues who are always supportive. This experience has been one of the best parts of my career journey, filled with lessons I will always carry with me.',
    testimony_title_6: 'Sri Wulan Zaenah – Customer Support',
    testimony_desc_6:
      'Since the first day I joined PT SOPRA, I found not just a place to work, but also a space to grow. A supportive environment, collaborative colleagues, and leaders who guide with care have made every workday a truly valuable experience for me.',
    benefit_title_1: 'Career Growth & Learning',
    benefit_desc_1:
      'Opportunities to develop your skills, participate in training programs, and advance your career.',
    benefit_title_2: 'Supportive Environment',
    benefit_desc_2:
      'Thrive in a team that’s always got your back, where collaboration, mentorship, and genuine support help you do your best every day.',
    benefit_title_3: 'Recognition & Engagement',
    benefit_desc_3:
      'Your effort doesn’t go unnoticed. We celebrate wins, give feedback, and keep things fun and engaging.',
    benefit_title_4: 'Continuous Improvement Culture',
    benefit_desc_4:
      'A culture that encourages innovation, values new ideas, and focuses on ongoing growth and efficiency.',
    latest_jobs: 'Latest Jobs',
    read_more: 'Read More',
    hire_title_desc:
      'We believe the right people don’t just fit in. they help us grow stronger. That’s why at SOPRA, we look for talent that’s passionate, adaptable, and ready to thrive in a culture built on teamwork.',
    hire_step1_title: 'Apply Online',
    hire_step1_desc:
      'Submit your application and upload your CV through our website. Quick and simple.',
    hire_step2_title: 'CV Screening',
    hire_step2_desc:
      'Our HR team will review your CV to ensure it matches the role requirements.',
    hire_step3_title: 'Psychological Test & Assesment',
    hire_step3_desc:
      'Showcase your skills through a psychological test or relevant assignment. Relax, it’s not about right or wrong answers. The goal is to understand how you think, work, and adapt. Just be yourself.',
    hire_step4_title: 'HR Interview',
    hire_step4_desc:
      'A friendly chat with our HR team to learn more about you, your background, and your career goals.',
    hire_step5_title: 'User Interview',
    hire_step5_desc:
      'A discussion with your potential manager or team lead to dive deeper into the role and how you’ll fit in.',
    hire_step6_title: 'Congratulations, You’re In!',
    hire_step6_desc:
      'Get your offer, start onboarding, and welcome to the team.',
    here: 'here',
    jobs_are_available: 'Jobs are available',
    faq_title1: 'Recruitment Process',
    faq_title2: 'Working at SOPRA',
    faq_title3: 'Benefits & Opportunities',
    faq_title4: 'Stay Updated!',
    faq_title1: 'Recruitment Process',
    faq_q1: 'How do I apply for a job at SOPRA Group?',
    faq_a1:
      'You can apply directly through our Career Page by selecting the available position and submitting your CV and supporting documents.',
    faq_q2: 'What does the recruitment process look like?',
    faq_a2:
      'Our recruitment process generally includes application screening, psychological test, HR interview, user interview, and an offer stage. Depending on the position, there may also be an assessment or certain technical test.',
    faq_q3: 'How long does the hiring process usually take?',
    faq_a3:
      'The process may vary, but on average it takes 2–4 weeks from application to offer.',
    faq_q4: 'How do I know if a SOPRA email or website is legit?',
    faq_a4:
      'Official communication from SOPRA Group will always come from our verified domains (e.g. sopra-pack.com and trass-pack.com ). We never request payment or sensitive personal data outside the recruitment process. If you are facing a potential scam or have any doubts, please contact our recruitment team at recruitment.01@sopra-pack.com',
    faq_q5: 'I just submitted my application, what can I expect?',
    faq_a5:
      'Once you submit your application, our HR team will review it carefully. If your profile matches the requirements, we will contact you for the next stage of the recruitment process. Regardless of the outcome, every applicant will receive follow-up communication from us.',
    faq_q6: 'Can I contact HR if my recruitment process seems stuck?',
    faq_a6:
      'Yes, but only if you are already in the middle of the recruitment process (for example, after an interview or assessment) and have not received any updates for some time. In that case, you may contact our recruitment team at recruitment.01@sopra-pack.com',
    faq_q7: 'What is the work culture like at SOPRA Group?',
    faq_a7:
      'We foster a collaborative, supportive, and innovative culture where every team member is encouraged to grow, share ideas, and take on challenges.',
    faq_q8: 'Are there opportunities for learning and development?',
    faq_a8:
      'Yes. SOPRA provides various training programs, mentorship, and even scholarship opportunities to help employees develop professionally and personally.',
    faq_q9: 'Does SOPRA support career growth?',
    faq_a9:
      'Absolutely. We believe in growing together. Many of our employees have advanced their careers through promotions, rotations, and skill development programs. Benefits & Opportunities',
    faq_q10: 'What benefits does SOPRA offer to employees?',
    faq_a10:
      'In addition to a competitive salary, we provide allowances, health & safety programs, development opportunities, and a supportive work environment.',
    faq_q11: 'Can I apply for multiple positions at the same time?',
    faq_a11:
      'Yes, as long as you meet the qualifications listed for each position.',
    faq_q12: 'Does SOPRA offer internship opportunities?',
    faq_a12:
      'Yes. We welcome students and fresh graduates through internships and trainee programs to help them gain real work experience.',
    faq_q13: 'How can I stay updated on job openings at SOPRA Group?',
    faq_a13:
      'You can regularly check our Career Page or follow our official social media channels for the latest updates on job opportunities.',
    stay_updated: 'Stay Updated!',
    more_reads: 'More Reads',
    search_job_hint: 'Search job title, skill, or keyword',
    search_job_hint_footer: 'Start your job search here',
    footer_desc:
      'We’re looking for all kinds of people. We hire people who are good at what they do. But just as important, are a good match for us. We want to have the best qualified people in every job.',
    location: 'Location',
    department: 'Department',
    jobType: 'Job Type',
    orderBy: 'Order By',
    sustainability: 'Sustainability',
    innovation: 'Innovation',
    transparency: 'Transparency',
    efficiency: 'Efficiency',
    collaboration: 'Collaboration',
    core_value_desc1:
      'Commitment to reducing environmental impact through responsible materials and processes.',
    core_value_desc2:
      'Constantly improving and redefining packaging solutions to meet modern demands.',
    core_value_desc3:
      'Building trust through honest communication and ethical business practices.',
    core_value_desc4:
      'Delivering high-quality solutions while optimizing resources and reducing waste.',
    core_value_desc5:
      'Working closely with clients, partners, and communities to create a positive impact.',
    why_join: 'Why join',
    why_join_content_title:
      'When workplaces put people first, everyone benefits.',
    why_join_content_desc:
      'It doesn’t matter from where you join us or in what role. You’ll be supported to do your best work, enjoy your day-to-day and get where you want to go.',
    newest: 'Newest',
    oldest: 'Oldest',
    applied_jobs: 'Applied Jobs',
    candidate_profile: 'Candidate Profile',
    profile_detail: 'Profile Detail',
    full_name: 'Full Name',
    name: 'Name',
    place_of_birth: 'Place of Birth',
    date_of_birth: 'Date of Birth',
    date_of_birth_age_range_error:
      'Age must be between 16 and 55 years.',
    marital_status: 'Marital Status',
    religion: 'Religion',
    blood_type: 'Blood Type',
    national_id: 'National ID Number',
    driver_license_no: 'Driver License Number',
    weight: 'Weight',
    height: 'Height',
    phone_number: 'Phone Number',
    email_address: 'Email Address',
    password: 'Password',
    confirm_password: 'Confirm Password',
    current_address: 'Current Address',
    next: 'Next',
    actions: 'Actions',
    family_structure: 'Family Structure',
    relation: 'Relation',
    gender: 'Gender',
    education: 'Education',
    occupation: 'Occupation',
    previous: 'Previous',
    education: 'Education',
    institution: 'Institution',
    degree: 'Degree',
    major: 'Major',
    start_date: 'Start Date',
    end_date: 'End Date',
    gpa: 'GPA',
    work_xperience: 'Work Experience',
    experience: 'Experience',
    position: 'Position',
    company: 'Company',
    base_salary: 'Take Home Pay (IDR)',
    job_description: 'Job Description',
    organization: 'Organization',
    rejected: 'Rejected',
    reject_remarks: 'Rejection Reason',
    hired: 'Hired',
    applied: 'Applied',
    screening: 'Screening',
    assessment: 'Assessment',
    psychotest: 'Psychotest',
    interview: 'Interview',
    interview_hc: 'Interview HC',
    interview_user: 'Interview User',
    medical_check_up: 'Medical Check Up',
    job_offer: 'Job Offer',
    date: 'Date',
    last_position: 'Last Position',
    age: 'Age',
    certification: 'Certification',
    certificate_name: 'Certificate Name',
    Credential_uRL: 'Credential URL',
    login: 'Log In',
    profile: 'Profile',
    my_application: 'My Application',
    logout: 'Log Out',
    verify: 'Verify',
    resend: 'Resend',
    share: 'Share',
    make_your_move: 'Make Your Move',
    link_coppied: 'Link Coppied!',
    full_name_required: 'Full Name is required',
    phone_number_required: 'Phone number in valid format is required',
    phone_number_format_wrong: 'Phone number format is wrong',
    please_fill_your_otp: 'Please fill your OTP!',
    please_verify_your_email: 'Please verify your email!',
    email_required: 'Email is required',
    cv_required: 'Please upload your CV',
    uploadFile: 'Upload File (Max. 2MB)',
    invalid_email_format: 'Email format is not valid',
    please_verify_before_continuing:
      'Please verify email address before continuing',
    please_select_a_valid_PDF_file: 'Please select a valid PDF file',
    file_is_too_large: 'File is too large',
    we_sent_otp_to_email: 'Please enter the OTP code we have sent to',
    email_is_required: 'Email is required',
    invalid_otp: 'OTP invalid or expired',
    required_error: 'Enter all required data with (*) symbol!',
    skillIsRequired: 'Skill is required!',
    required_family: 'father and mother data is required!',
    add_family_member: 'Add Family Member',
    no_education: 'No education added yet',
    no_education_desc:
      'Add your latest education background to complete your profile.',
    add_edu: 'Add Education',
    required_form: 'Form cannot be empty',
    no_organization: 'No organizations added yet',
    no_organization_desc:
      'Start building your profile by adding the organizations you’ve been part of.',
    no_applied_jobs: 'No jobs applied yet',
    no_applied_jobs_desc: 'Start applying to jobs and they will appear here.',
    add_org: 'Add Organization',
    year: 'Year',
    language_proficiency: 'Foreign Language Proficiency',
    no_language: 'No foreign language proficiency added yet',
    no_language_desc:
      'Start building your profile by adding your foreign language proficiency',
    add_anguage: 'Add Language',
    language: 'Language',
    speaking: 'Speaking',
    writing: 'Writing',
    no_work_exp: 'No work experience added yet',
    no_work_exp_desc:
      'Add your work/internship experience to showcase your expertise.',
    add_work_exp: 'Add work experience',
    sector: 'Sector',
    company_address: 'Company Address',
    leaving_reason: 'Reason for leaving',
    license_certifcate: 'Licenses & Certifications',
    add_license: 'Add Licenses & Certifications',
    issuing_org: 'Issuing Organization',
    issue_date: 'Issue Date',
    expiration_date: 'Expiration Date',
    profile_completion: 'Profile Completion',
    professional_references: 'Professional References',
    no_references: 'No references added yet',
    no_references_desc:
      'Start by adding supervisors, managers, or colleagues as your references.',
    no_license: 'No licenses or certifications yet',
    no_license_desc:
      'Add your professional licenses and certifications to showcase your qualifications and expertise.',
    no_socmed: 'No social media yet',
    no_socmed_desc: 'Add your social media to complete your profile.',
    agree_to_contact_references:
      'By continuing in the recruitment process, I consent to SOPRA Group collecting, storing, and processing my personal data for the purpose of evaluating my candidacy. I understand that the Company may verify references and use the results of assessments confidentially for recruitment decisions.',
    no_skill: 'No skills added yet',
    no_skill_desc:
      'Start by adding programming languages, tools, or professional skills.',
    apply_job_success: 'Your job application is successful!',
    apply_job_failed: 'Your job application is failed!',
    save_and_next: 'Save & Next',
    reference: 'Referesi',
    name_of_reference: 'Name of Reference',
    role_or_position: 'Role/Position',
    contact_references: 'Contact References',
    relationship: 'Relationship',
    save: 'Save',
    q1: 'Have you applied to PT. Solusi Prima Packaging in the past 12 months? If ever, please explain!',
    q2: 'Do you have any friends or relatives working at PT. Solusi Prima Packaging? If yes, please explain!',
    q3: 'Are you willing for us to request references from your previous employer?',
    q4: 'If accepted, are you willing to work in a shift system?',
    q5: 'If accepted, are you willing to travel for out-of-town assignments?',
    q6: 'If accepted, are you willing to be assigned to a location outside the city?',
    q7: 'Have you ever suffered from a serious illness, chronic disease, major accident, or undergone surgery? If ever, please explain!',
    q8: 'Have you ever had any dealings with the police? If yes, please explain!',
    q9: 'Do you have any permanent physical disabilities? If yes, please explain!',
    q10: 'Do you have experience working with a similar company or competitor? If ever, please explain!',
    q11: 'Where did you get the information about SOPRA?',
    q12: 'If accepted, when would you be available to start working?',
    q13: 'If accepted, what total remuneration (All-in/Take-home pay) do you expect?',
    ever: 'Ever',
    never: 'Never',
    willing: 'Willing',
    not_willing: 'Not Willing',
    choose_availability: 'Choose Availability',
    yes: 'Yes',
    no: 'No',
    submit: 'Submit',
    asap: 'Immediate',
    two_weeks: '2 Weeks',
    four_weeks: '4 Weeks',
    eight_weeks: '8 Weeks',
    morethan2month: 'More than 2 Month',
    answer: 'Answer',
    family: 'Family',
    add_skills: 'Add Skills & Technologies',
    skills_tech: 'Skills & Technologies',
    skill_name: 'Skill Name',
    success_to_send: 'Form sent successfully!',
    date_applied: 'Date Applied',
    application_progress: 'Application Progress',
    interview_scheduled: 'Interview Scheduled',
    all: 'All',
    all_applications: 'All Applications',
    active_applications: 'Active Applications',
    history: 'History',
    interview_mode: 'Interview mode',
    select_interview_time: 'Select interview time',
    helper_select_interview_time: 'Please choose a schedule that suits you.',
    selected_schedule: 'Selected',
    confirm_schedule: 'Confirm Schedule',
    reschedule: 'Reschedule',
    open_maps: 'Open Maps',
    full_slot: 'Full',
    available_slot: 'Available',
    no_active_applications: 'No active applications yet',
    no_active_applications_desc:
      'Your upcoming interview schedule will appear here once it is available.',
    no_history_applications: 'No application history yet',
    no_history_applications_desc:
      'Completed or archived applications will appear here.',
    interview_deadline_notice:
      'Choose your schedule before 3 Jun 2025. If you do not complete the booking before the deadline, your application may be considered withdrawn.',
    interview_deadline_before: 'Choose your schedule before',
    interview_deadline_after:
      'If you do not complete the booking before the deadline, your application may be considered withdrawn.',
    interview_booking_expires_in: 'Schedule booking expires in',
    interview_offline_note: 'Please come directly to the office',
    request_reschedule: 'Request Reschedule',
    request_reschedule_notice:
      'You are requesting a reschedule. Please choose a new schedule from the available dates below.',
    select_reschedule_date: 'Select Date',
    select_reschedule_time: 'Preferred time',
    reschedule_time_helper:
      'The times shown are available slots to choose from in WIB.',
    reschedule_note: 'Reason for reschedule',
    reschedule_note_placeholder: 'Write your reason or note for the HR team...',
    submit_reschedule_request: 'Send Request',
    cancel: 'Cancel',
    loading: 'Loading...',
    retry: 'Retry',
    no_data: 'No data',
    failed_to_load_data: 'Failed to load data',
    failed_to_load_jobs: 'Failed to load jobs',
    loading_applications: 'Loading applications...',
    applications_login_required:
      'Please log in first to access your applications',
    applications_load_failed: 'Unable to load your applications',
    interview_booking_load_failed: 'Unable to load interview booking data',
    select_interview_schedule_first:
      'Please choose an interview schedule first',
    interview_slot_selected_success: 'Interview slot selected successfully',
    interview_reschedule_request_success:
      'Interview reschedule request submitted successfully',
    interview_reschedule_waiting_title: 'Reschedule request submitted',
    interview_reschedule_waiting_desc:
      'Your reschedule request has been sent. Please wait for the next update from our recruitment team.',
    no_applications_found: 'No applications found',
    no_applications_found_desc: 'You have not applied to any jobs yet.',
    no_interview_schedule_available: 'No interview schedule available',
    no_interview_schedule_available_desc:
      'There are no interview schedules available at the moment.',
    interview_schedule: 'Interview Schedule',
    interview_link: 'Interview link',
    open_link: 'Open Link',
    slot_left: 'slot left',
    no_interview_slots_available: 'No interview slots available for this date.',
    book_interview: 'Book Interview',
    book_interview_hc: 'Book Interview HC',
    book_interview_user: 'Book Interview User',
    interview_schedule_available_desc:
      'You can now choose your interview schedule.',
    interview_invitation_expired_title: 'Interview invitation expired',
    interview_invitation_waiting_title:
      'Interview invitation is being prepared',
    interview_invitation_waiting_desc:
      'Your interview invitation is being prepared. Please wait for the next update from our recruitment team.',
    interview_invitation_expired_desc:
      'Your interview booking window has expired. Please wait for the next update from our recruitment team.',
    interview_invitation_used_title: 'Interview invitation unavailable',
    interview_invitation_used_desc:
      'This interview invitation link has already been used. Please wait for the next update from our recruitment team.',
    preferred_date: 'Preferred date',
    interview_hc_schedule: 'Interview HC Schedule',
    interview_user_schedule: 'Interview User Schedule',
    interview_selected_notice_before: 'Your interview schedule for',
    interview_selected_notice_at: 'at',
    interview_selected_notice_after:
      'has been selected. Please wait for further updates.',
    offer_confirmation: 'Offer Confirmation',
    agreed_take_home: 'Agreed take-home',
    basic_salary: 'Basic salary',
    transport_allowance: 'Transport allowance',
    meal_allowance: 'Meal allowance',
    health_insurance_bpjs: 'Health insurance (BPJS)',
    covered_by_company: 'Covered by company',
    probation_period: 'Probation period',
    job_offer_probation_end_evaluation: '(end of period evaluation)',
    job_offer_probation_period_value: '3 months (end of period evaluation)',
    job_offer_confidentiality_notice:
      'This information is confidential. This document may not be downloaded, printed, or shared.',
    job_offer_start_date_note: 'I commit to be present on the date I selected.',
    commitment_statement: 'Commitment statement',
    agree_commitment_statement: 'I agree to the commitment statement above',
    required: 'Required',
    confirm: 'Confirm',
    full_time: 'Full Time',
    job_offer_commitment_item_1:
      'I have read and understood all details of this job offer.',
    job_offer_commitment_item_2:
      'I agree to the compensation package, work location, and agreed start date.',
    job_offer_commitment_item_3: 'I commit to be present on the selected date.',
    job_offer_commitment_item_4:
      'I understand that this information is confidential and will not be disclosed.',
    job_offer_confirmation_pending_title: 'Confirmation is not connected yet',
    job_offer_confirmation_pending_desc:
      'This job offer confirmation is currently frontend slicing only and will be connected to the API later.',
    job_offer_positional_allowance: 'Positional allowance',
    job_offer_operational_allowance: 'Operational allowance',
    total_salary_received: 'Total salary received',
    job_offer_waiting_desc:
      'Your job offer details are still being prepared. Please wait for the next update from the recruitment team.',
    medical_check_up_notice_prefix:
      'Your documents have been received. Please keep an eye on ',
    medical_check_up_notice_email_bold: 'your email for further updates',
    medical_check_up_notice_middle:
      " from our HR team and don't forget to check your ",
    medical_check_up_notice_spam_bold: 'Spam folder',
    medical_check_up_notice_suffix: ' as well.',
    job_offer_expired_title: 'Job offer has expired',
    job_offer_expired_desc:
      'The confirmation deadline for this job offer has passed. Please wait for the next update from the recruitment team.',
    job_offer_otp_pending_desc:
      'Enter the OTP code to continue to the pre-onboarding document step.',
    job_offer_confirm_before_desc:
      'Please confirm this offer before the deadline so you can continue to the OTP verification step.',
    job_offer_deadline_title: 'Offer ends in',
    job_offer_otp_deadline_title: 'OTP ends',
    job_offer_expiry_label: 'Expires',
    job_offer_confirm_validation:
      'Please choose a start date and agree to the commitment statement first.',
    job_offer_otp_generated_title: 'OTP generated successfully',
    job_offer_otp_generated_desc:
      'The OTP code has been saved successfully. You can continue the verification step once you have the code.',
    job_offer_otp_required: 'Please enter the OTP code first.',
    job_offer_otp_verified_title: 'OTP verified successfully',
    job_offer_otp_verified_desc:
      'You can continue to fill in the pre-onboarding documents.',
    job_offer_otp_title: 'OTP Verification',
    job_offer_otp_manual_desc:
      'OTP delivery by email is still pending. For now, use the OTP code saved in the backend manually.',
    job_offer_request_otp_wait: 'Please wait before requesting another OTP',
    second_abbrev: 's',
    job_offer_identity_verification_title: 'Identity Verification',
    job_offer_otp_sent_to: 'A 6-digit OTP code has been sent to',
    job_offer_signature_title: 'Job offer approval signature',
    job_offer_signature_desc:
      'Enter the OTP code to complete your approval. This code acts as your digital signature for this job offer.',
    job_offer_resend_prompt: 'Did not receive the code?',
    job_offer_resend_otp: 'Resend',
    job_offer_generate_otp_again: 'Generate OTP Again',
    otp_code: 'OTP Code',
    input_otp: 'Enter OTP',
    verify_otp: 'Verify OTP',
    error_title: 'Error!',
    uploading: 'Uploading...',
    month: 'month',
    other_benefit: 'Other benefit',
    pre_onboarding_checklist: 'Pre-Onboarding Checklist',
    pre_onboarding_subtitle:
      'Upload all required documents to begin the onboarding process.',
    document_fill_expires_in: 'Document fill expires in',
    expires: 'Expires',
    optional: 'Optional',
    choose_file: 'Choose File',
    upload_prompt_click_or_drag: 'Click to upload or drag & drop',
    upload_prompt_drop_or_click: 'Drop files here or click to upload',
    upload_support_formats: 'Support JPG, JPEG, PNG & PDF files up to 2MB',
    ktp: 'National Identity Card - KTP',
    ktp_number: 'KTP Number',
    input_ktp: 'Input KTP',
    ktp_upload_desc: 'Upload a photo or scan of your valid National ID Card.',
    kk: 'Family Card - KK',
    kk_number: 'KK Number',
    input_kk: 'Input KK Number',
    kk_upload_desc: 'Upload a photo or scan of your valid Family Card.',
    npwp: 'Taxpayer Identification Number - NPWP',
    npwp_number: 'NPWP Number',
    input_npwp: 'Input NPWP',
    npwp_upload_desc: 'Upload a photo or scan of your NPWP card.',
    bank_account_details: 'Bank Account Details',
    bank_account_upload_desc:
      'Enter your BCA account details for payroll setup.',
    bank_name: 'Bank Name',
    input_bank_name: 'BCA Only',
    account_number: 'Account Number',
    input_account_number: 'Input Number',
    account_holder_name: 'Account Holder Name',
    input_account_holder_name: 'As per bank book',
    bank_book_upload_note:
      'Or upload a photo of the first page of your bank book:',
    emergency_contact: 'Emergency Contact',
    emergency_contact_desc:
      'Enter the name, relationship, and phone number of your emergency contact.',
    emergency_contact_name_placeholder: 'Emergency contact name',
    emergency_contact_phone_placeholder: '+62 8XX XXXX XXXX',
    emergency_contact_relationship_placeholder: 'e.g. Parent, Spouse',
    bpjs_kesehatan_ketenagakerjaan: 'BPJS Kesehatan & Ketenagakerjaan',
    bpjs_upload_desc:
      'Upload your BPJS card if you already have one. Optional if not yet registered.',
    bpjs_kesehatan: 'BPJS Kesehatan',
    bpjs_ketenagakerjaan: 'BPJS Ketenagakerjaan',
    pre_onboarding_declaration_heading: 'Declaration statement',
    pre_onboarding_declaration_title:
      'By submitting this data, I declare that:',
    pre_onboarding_declaration_item_1:
      'All information and documents I have provided are true and valid.',
    pre_onboarding_declaration_item_2:
      'I am willing to accept the consequences if any data is found to be inaccurate.',
    pre_onboarding_declaration_item_3:
      'This data will be used for the onboarding process by the HR team.',
    pre_onboarding_agree_declaration_statement:
      'I agree to the declaration statement above',
    pre_onboarding_ktp_required: 'KTP number is required.',
    pre_onboarding_ktp_invalid: 'KTP number must contain exactly 16 digits.',
    pre_onboarding_kk_required: 'KK number is required.',
    pre_onboarding_kk_invalid: 'KK number must contain exactly 16 digits.',
    pre_onboarding_npwp_required: 'NPWP number is required.',
    pre_onboarding_npwp_invalid: 'NPWP number must contain exactly 15 digits.',
    pre_onboarding_bank_name_required: 'Bank name is required.',
    pre_onboarding_bank_name_invalid: 'Enter a valid bank name.',
    pre_onboarding_account_number_required: 'Account number is required.',
    pre_onboarding_account_number_invalid:
      'Account number must contain 8 to 20 digits.',
    pre_onboarding_account_holder_name_required:
      'Account holder name is required.',
    pre_onboarding_account_holder_name_invalid:
      'Enter a valid account holder name.',
    pre_onboarding_emergency_contact_name_required:
      'Emergency contact name is required.',
    pre_onboarding_emergency_contact_name_invalid:
      'Enter a valid emergency contact name.',
    pre_onboarding_emergency_contact_phone_required:
      'Emergency contact phone number is required.',
    pre_onboarding_emergency_contact_phone_invalid:
      'Enter a valid phone number.',
    pre_onboarding_relationship_required: 'Relationship is required.',
    pre_onboarding_relationship_invalid: 'Enter a valid relationship.',
    pre_onboarding_file_required: 'Please upload this document.',
    pre_onboarding_file_invalid:
      'Only JPG, JPEG, PNG, or PDF files are allowed.',
    pre_onboarding_file_too_large: 'File size must be 2MB or less.',
    pre_onboarding_file_upload_failed:
      'Failed to upload the selected file. Please try again.',
    pre_onboarding_declaration_required:
      'Please confirm the declaration before submitting.',
    pre_onboarding_submitted_title: 'Pre-onboarding submitted',
    pre_onboarding_submitted_desc:
      'Your pre-onboarding documents have been submitted successfully. Please wait for the next update from the HR team.',
    pre_onboarding_expired_title: 'Pre-onboarding has expired',
    pre_onboarding_expired_desc:
      'The time limit to submit these documents has passed. Please wait for the next update from the HR team.',
    pre_onboarding_submit_success: 'Pre-onboarding submitted successfully.',
    submitted: 'Submitted',
    general_questions: 'General Questions',
    select_source: 'Select Source',
    other: 'Other',
    emailregistered: 'Email is already registered',
    already_have_an_account: 'Already have an account?',
    dont_have_an_account: "Don't have an account?",
    password_required: 'Password is required',
    password_length: 'Minimum password Length is 6 characters',
    password_not_match: 'Password not match',
    profile_not_complete: 'Profile not complete!',
    session_expired: 'Session expired, please login to continue!',
    forget_password: 'Forget password',
    register_info: 'You need to have an account to proceed the application!',
    login_required_title: 'Login Required',
    please_login: 'Please Log In',
    sign_in_desc: 'Sign in to your account to continue',
    login_to_apply_desc: 'Please log in first to continue your job application',
    hello: 'Hello',
    temp_password_change_desc: 'please change your password to continue.',
    forget_password_desc: 'Verify your email to continue',
    remember_me: 'Remember me',
    register: 'Register',
    new_password: 'New Password',
    register_to_proceed: 'Register to Continue',
    change_password: 'Change Your Password',
    back: 'Back',
    register_success: 'Account registration is successful',
    change_password_success: 'Password has changed successfuly',
    set_password: 'Create password for your account',
    set_new_password: 'Create your new password',
    invalid_link: 'Link is invalid',
    enter_email: 'Enter your email',
    enter_password: 'Enter your password',
    enter_new_password: 'Enter new password',
    confirm_new_password: 'Confirm new password',
    enter_name: 'Enter your name',
    enter_phone_number: 'Enter your phone number',
    sign_up: 'Sign Up',
    continue: 'Continue',
    warning: 'Warning',
    information: 'Information',
    work_exp_subtitle:
      'Add your work/internship experience to showcase your expertise',
    edu_subtitle:
      'The latest education will automatically be placed at the top.',
    org_subtitle:
      'The latest organization will automatically be placed at the top.',
    pref_subtitle:
      'The latest professional references will automatically be placed at the top.',
    complete_before: 'Please complete before',
    pre_assessment_expires_in: 'Pre assessment expires in',
    assessment_expires_in: 'Assessment expires in',
    pretest_screening_desc:
      'Your pre assessment is available. Please complete it to continue to the next stage.',
    pretest_finished_title: 'Pre Assessment Completed!',
    pretest_finished_desc:
      'Thank you for completing the pre assessment. Your answers have been saved and submitted.',
    pretest_finished_hint: 'You can close this page.',
    pretest_already_completed_title:
      'You Have Already Completed the Pre Assessment',
    pretest_already_completed_desc:
      'Your pre assessment has already been submitted. Please wait for the next update from the recruitment team.',
    pretest_already_completed_hint:
      'Please wait for the next update from the recruitment team.',
    pretest_expired_title: 'Pre Assessment Time Is Up',
    pretest_expired_desc:
      'The time limit to complete your pre assessment has passed. Please wait for the next update from the recruitment team.',
    pretest_card_title: 'Pre Assessment',
    pretest_card_desc:
      'Answer each question honestly and submit before the time end.',
    pretest_portal_note:
      'After completing the pre assessment, you can monitor your recruitment progress through the job portal',
    open_pretest: 'Open Pre Assessment',
    open_assessment: 'Open Assessment',
    open_psychotest: 'Open Psychotest',
    internet_error_title: 'Network Error!',
    internet_error: 'Please check your connection, and try again!',
    proceed: 'Proceed',
    checkNoExperience:
      "Please check the statement bellow if you don't have any work experience!",
    noExperience: "I don't have any work experience",
    isMyCurrentJob: 'Still Working',
    total_beginner: 'Beginner',
    active: 'Active',
    passive: 'Passive',
    advanceLevel: 'Advance Level',
    intermediateLevel: 'Intermediate Level',
    beginnerLevel: 'Beginner Level',
    advanced: 'Advanced',
    intermediate: 'Intermediate',
    beginner: 'Beginner',
    haveJobExp: 'I have work experience',
    haveNoJobExp: "I don't have work experience",
    chooseWorkExpStatus: 'Choose your work experience status!',
    inputWorkExp: 'Input your work experience!',
    raising_star: 'Raising STAR',
    raising_title:
      "SOPRA Raising Talent is designed to empower future talents through strategic, long-term education partnerships, forming a sustainable talent acquisition ecosystem fully integrated into SOPRA's recruitment strategy.",
    goals: 'Goals',
    goals1_title: 'Strategic Education Partnership',
    goals2_title: 'Industry-Ready Talent Development',
    goals1_description:
      'Building long-term collaborations with educational institutions aligned with industry needs.',
    goals2_description:
      'Equipping students with the competencies, mindset, and readiness required in the professional world.',
    highlights2_description:
      "Equipping future talent with the knowledge and confidence to succeed in today's recruitment landscape.",
    highlights1_description:
      'Dedicated career opportunities exclusively for students and alumni of partner institutions.',
    job_fair_description:
      'SOPRA Group regularly joins job fairs and career events to connect with future talents. These events give you the opportunity to get to know SOPRA better,  from our company culture and career paths to the opportunities available across our group.',
  },
  id: {
    modal_header: 'Waspada Penipuan Rekrutmen Karyawan',
    modal_desc:
      'tidak memungut biaya apapun dalam proses rekrutmen. Hindari penipuan dengan mencermati email dan situs web yang digunakan untuk lowongan pekerjaan. Kami tidak bertanggung jawab atas penipuan lowongan pekerjaan yang mengatasnamakan Sopra Group.',
    modal_desc_2:
      'Untuk memastikan informasi iklan lowongan pekerjaan di SOPRA, hubungi kami melalui email: recruitment01@solusi-pack.com atau kunjungi website resmi kami di: portal.solusi-pack.com',
    home_title1: 'Temukan',
    home_title2: 'tempat Anda',
    at: 'di',
    life_at: 'Suasana',
    navigation: 'Navigasi',
    life_at_sopra: 'Suasana SOPRA',
    how_we_hire: 'Sistem Rekrutmen',
    build_your: 'Bangun',
    career: 'karir',
    teams: 'Tim',
    blogs: 'Blogs',
    faq: 'FAQ',
    still: 'Masih',
    curious: 'penasaran',
    explore_jobs: 'Lowongan Kerja',
    intro_desc_1:
      'Di SOPRA, setiap orang punya kesempatan untuk bersinar, dan setiap ide lebih berharga daripada sekadar jabatan. Kami percaya pentingnya semangat berinovasi, dukungan satu sama lain, dan berbagi kebahagiaan atas setiap keberhasilan. Dengan budaya yang terbuka dan suportif, kami menghadapi tantangan bersama dan menciptakan solusi yang berdampak. Kami menantikan kehadiran Anda untuk tumbuh dan melangkah bersama dalam perjalanan ini.',
    intro_title_2: 'Membuka Potensi Anda',
    intro_desc_2:
      'Kami percaya bahwa pertumbuhan dimulai sejak hari pertama. Sejak Anda bergabung, Anda akan dipercayakan dengan proyek-proyek yang bermakna yang akan mengembangkan keterampilan Anda, membangun kepercayaan diri, dan mengakselerasi perjalanan karier Anda. Di sini, kami memberikan Anda kesempatan untuk menggali potensi terbaik dalam diri Anda.',
    intro_title_3: 'Perkenalkan Direktur Kami',
    intro_desc_3:
      'Kami tidak hanya menghadirkan solusi kemasan, tetapi juga menghadirkan masa depan. Di SOPRA, setiap proyek adalah kesempatan untuk berinovasi, setiap kerja sama adalah peluang untuk memberi inspirasi, dan setiap langkah maju adalah wujud komitmen terhadap keunggulan. Ambisi kami jelas: berinovasi, menetapkan standar baru bagi industri, dan meninggalkan jejak yang benar-benar berarti. Semua ini bisa terwujud karena kami percaya pada pemikiran besar dan bergerak dengan tujuan yang jelas. Sekarang, kami mencari orang-orang yang memiliki passion yang sama. Kalian yang penuh dengan rasa ingin tahu, berani, digerakkan oleh inovasi, berkomitmen untuk terus berkembang, dan memiliki tekad untuk membawa perubahan nyata.',
    intro_subDesc_3:
      'Masa depan penuh dengan peluang, dan kami tak sabar menantimu untuk menjadi bagian di dalamnya.',
    testimony_title_1: 'Lukito - Assistant Manager Produksi',
    testimony_desc_1:
      'Sebelum di SOPRA Group, saya berpengalaman sebagai supervisor extruder, terutama di proses produksi dengan pengetahuan terbatas tentang electrical. Setelah bergabung dengan SOPRA Group, saya banyak berkembang, terutama pada skill teknis seperti electrical, mechanical, dan utility. Perjalanan saya semakin bermakna ketika mendapat kesempatan beasiswa untuk kuliah empat tahun hingga meraih gelar sarjana teknik. Terima kasih SOPRA.',
    testimony_title_2: 'Koko Santoso - Assistant HR Manager',
    testimony_desc_2:
      'Bekerja di SOPRA Group adalah pengalaman penuh tantangan sekaligus menyenangkan. Budayanya unik dan selalu bikin termotivasi, ditambah dengan orang-orangnya yang terbuka untuk kolaborasi dan saling mendukung. Hal yang paling saya senangi adalah bagaimana SOPRA memberi ruang untuk berinovasi dan bebas mengeksplorasi ide-ide baru. Lingkungan ini mendorong saya terus berkembang secara profesional, sekaligus membuat setiap hari kerja terasa lebih berarti.',
    testimony_title_3: 'Ergha Thoriq - Sales Executive',
    testimony_desc_3:
      'Mulai dari HR sampai tim leader, semua menyambut dengan hangat dan membimbing dengan cara yang friendly. Ditambah rekan kerja yang selalu support, bikin suasana kerja di SOPRA terasa kekeluargaan tapi tetap profesional.',
    testimony_title_4: 'Alvix Robby - Supervisor GA-HSE',
    testimony_desc_4:
      'Bekerja di SOPRA Group itu berkesan karena selalu dinamis, penuh tantangan, dan ada saja hal baru yang membuka ruang untuk belajar dan berkembang. Hal yang paling berkesan bagi saya adalah bekerja bersama tim yang solid sehingga suasana jadi asik dan kolaboratif, ditambah leader yang selalu siap memberi dukungan dan arahan agar saya bisa terus berkembang, baik secara personal maupun profesional.',
    testimony_title_5: 'Naseh Hudin – Supervisor Produksi',
    testimony_desc_5:
      'Selama bekerja di PT SOPRA, saya merasakan lingkungan kerja yang profesional sekaligus mendukung pengembangan diri. Banyak ilmu dan pengalaman berharga yang saya dapatkan. Bagi saya, bekerja di PT SOPRA bukan hanya soal pekerjaan, tetapi juga soal keluarga karena rekan-rekan yang selalu mendukung. Pengalaman ini menjadi salah satu hal terbaik dalam perjalanan karier saya, dengan banyak pelajaran yang akan selalu saya ingat.',
    testimony_title_6: 'Sri Wulan Zaenah – Customer Support',
    testimony_desc_6:
      'Sejak pertama kali bergabung di PT SOPRA, saya tidak hanya menemukan tempat untuk bekerja, tetapi juga ruang untuk bertumbuh. Lingkungan yang nyaman, rekan kerja yang penuh kebersamaan, serta pimpinan yang membimbing dengan baik menjadikan setiap hari kerja sebagai pengalaman yang berharga bagi saya.',
    benefit_title_1: 'Pengembangan Karier & Pembelajaran',
    benefit_desc_1:
      'Kesempatan untuk mengasah keterampilan, mengikuti program pelatihan, dan membangun karier Anda.',
    benefit_title_2: 'Lingkungan Kerja yang Mendukung',
    benefit_desc_2:
      'Berkembang bersama tim yang selalu saling mendukung, dengan kolaborasi, mentorship, dan dukungan nyata agar Anda bisa memberikan yang terbaik setiap hari',
    benefit_title_3: 'Apresiasi & Keterlibatan',
    benefit_desc_3:
      'Setiap usaha tidak akan luput dari perhatian. Kami merayakan pencapaian, memberikan feedback, dan menjaga suasana kerja tetap menyenangkan serta penuh keterlibatan.',
    benefit_title_4: 'Budaya Inovasi Berkelanjutan',
    benefit_desc_4:
      'Budaya yang mendorong inovasi, menghargai ide-ide baru, dan berfokus pada pertumbuhan serta efisiensi yang terus berkelanjutan.',
    latest_jobs: 'Lowongan Terbaru',
    read_more: 'Lebih Banyak',
    hire_title_desc:
      'Kami percaya, orang yang tepat bukan hanya sekadar menyesuaikan diri, tetapi juga membantu kami tumbuh lebih kuat. Karena itu, di SOPRA kami mencari talenta yang penuh semangat, mudah beradaptasi, dan siap berkembang dalam budaya yang dibangun atas dasar kerja sama tim.',
    hire_step1_title: 'Lamar Online',
    hire_step1_desc:
      'Kirimkan lamaran Anda dan unggah CV melalui website kami. Cepat dan mudah.',
    hire_step2_title: 'Seleksi CV',
    hire_step2_desc:
      'Tim Tim HR kami akan meninjau CV Anda untuk memastikan sesuai dengan kualifikasi posisi yang dilamar.',
    hire_step3_title: 'Tes Psikologi & Assessment',
    hire_step3_desc:
      'Tunjukkan kemampuan Anda melalui tes psikologi atau tugas yang relevan. Tenang, ini bukan soal jawaban benar atau salah. Tujuannya adalah untuk memahami bagaimana cara Anda berpikir, bekerja, dan beradaptasi. Jadi, cukup jadi diri sendiri.',
    hire_step4_title: 'Interview HR',
    hire_step4_desc:
      'Sesi percakapan dengan tim HR kami untuk mengenal Anda lebih jauh, termasuk latar belakang serta tujuan karier Anda.',
    hire_step5_title: 'Interview User',
    hire_step5_desc:
      'Diskusi bersama calon manajer atau pimpinan tim Anda untuk memahami lebih dalam mengenai peran yang dilamar dan bagaimana Anda dapat menyesuaikan diri.',
    hire_step6_title: 'Selamat, Anda Diterima!',
    hire_step6_desc:
      'Terima tawaran Anda, mulai proses onboarding, dan selamat bergabung dalam tim.',
    here: 'disini',
    jobs_are_available: 'Lowongan tersedia',
    faq_title1: 'Proses Rekrutmen',
    faq_title2: 'Bekerja di SOPRA',
    faq_title3: 'Benefit & Kesempatan',
    faq_title4: 'Dapatkan Informasi Terbaru!',
    faq_q1: 'Bagaimana cara melamar pekerjaan di SOPRA Group?',
    faq_a1:
      'Anda dapat melamar langsung melalui Halaman Karir kami dengan memilih posisi yang tersedia dan mengirimkan CV serta dokumen pendukung.',
    faq_q2: 'Seperti apa proses rekrutmen di SOPRA Group?',
    faq_a2:
      'Proses rekrutmen kami umumnya mencakup penyaringan lamaran, tes psikologi, wawancara HR, wawancara user, dan tahap penawaran. Tergantung posisi, mungkin juga ada asesmen atau tes teknis tertentu.',
    faq_q3: 'Berapa lama biasanya proses perekrutan berlangsung?',
    faq_a3:
      'Prosesnya bisa bervariasi, tetapi rata-rata memakan waktu 2–4 minggu sejak melamar hingga tahap penawaran.',
    faq_q4: 'Bagaimana cara memastikan email atau website SOPRA itu resmi?',
    faq_a4:
      'Komunikasi resmi dari SOPRA Group selalu berasal dari domain terverifikasi kami (misalnya sopra-pack.com dan trass-pack.com). Kami tidak pernah meminta pembayaran atau data pribadi sensitif di luar proses rekrutmen. Jika Anda menghadapi potensi penipuan atau ragu, silakan hubungi tim rekrutmen kami di recruitment.01@sopra-pack.com',
    faq_q5: 'Saya baru saja mengirimkan lamaran, apa yang bisa saya harapkan?',
    faq_a5:
      'Setelah Anda mengirimkan lamaran, tim HR kami akan meninjaunya dengan cermat. Jika profil Anda sesuai dengan persyaratan, kami akan menghubungi Anda untuk tahap berikutnya. Apapun hasilnya, setiap pelamar akan menerima tindak lanjut komunikasi dari kami.',
    faq_q6:
      'Bisakah saya menghubungi HR jika proses rekrutmen saya terasa terhenti?',
    faq_a6:
      'Ya, tetapi hanya jika Anda sudah berada di tengah proses rekrutmen (misalnya setelah wawancara atau tes) dan tidak menerima kabar selama beberapa waktu. Dalam hal ini, Anda dapat menghubungi tim rekrutmen kami di recruitment.01@sopra-pack.com',
    faq_q7: 'Seperti apa budaya kerja di SOPRA Group?',
    faq_a7:
      'Kami menumbuhkan budaya kolaboratif, suportif, dan inovatif di mana setiap anggota tim didorong untuk berkembang, berbagi ide, dan menghadapi tantangan.',
    faq_q8: 'Apakah ada kesempatan untuk belajar dan berkembang?',
    faq_a8:
      'Ya. SOPRA menyediakan berbagai program pelatihan, pendampingan, dan bahkan peluang beasiswa untuk membantu karyawan berkembang secara profesional maupun pribadi.',
    faq_q9: 'Apakah SOPRA mendukung pengembangan karier?',
    faq_a9:
      'Tentu saja. Kami percaya untuk tumbuh bersama. Banyak karyawan kami yang mengembangkan karier mereka melalui promosi, rotasi, dan program pengembangan keterampilan. Manfaat & Peluang',
    faq_q10: 'Apa saja manfaat yang ditawarkan SOPRA kepada karyawan?',
    faq_a10:
      'Selain gaji yang kompetitif, kami memberikan tunjangan, program kesehatan & keselamatan, peluang pengembangan, serta lingkungan kerja yang suportif.',
    faq_q11: 'Bisakah saya melamar untuk beberapa posisi sekaligus?',
    faq_a11:
      'Ya, selama Anda memenuhi kualifikasi yang tercantum pada setiap posisi.',
    faq_q12: 'Apakah SOPRA menawarkan program magang?',
    faq_a12:
      'Ya. Kami menyambut mahasiswa dan fresh graduate melalui program magang dan trainee untuk membantu mereka mendapatkan pengalaman kerja nyata.',
    faq_q13:
      'Bagaimana cara saya tetap mendapatkan informasi lowongan di SOPRA Group?',
    faq_a13:
      'Anda dapat secara rutin memeriksa Halaman Karir kami atau mengikuti saluran media sosial resmi kami untuk update terbaru mengenai kesempatan kerja.',
    stay_updated: 'Dapatkan Informasi Terbaru!',
    more_reads: 'Baca lebih',
    search_job_hint: 'Cari judul lowongan, skill, atau kata kunci',
    search_job_hint_footer: 'Mulai mencari pekerjaan disini',
    footer_desc:
      'Kami mencari berbagai macam orang. Kami merekrut orang-orang yang ahli dalam bidangnya. Namun yang tidak kalah penting, mereka juga harus cocok dengan kami. Kami ingin memiliki orang-orang paling berkualitas di setiap pekerjaan.',
    location: 'Lokasi',
    department: 'Departemen',
    jobType: 'Tipe Job',
    orderBy: 'Urutkan',
    sustainability: 'Keberlanjutan',
    innovation: 'Inovasi',
    transparency: 'Transparansi',
    efficiency: 'Efisiensi',
    collaboration: 'Kolaborasi',
    core_value_desc1:
      'Komitmen untuk mengurangi dampak lingkungan melalui bahan dan proses yang bertanggung jawab.',
    core_value_desc2:
      'Terus meningkatkan dan mendefinisikan kembali solusi pengemasan untuk memenuhi tuntutan modern.',
    core_value_desc3:
      'Membangun kepercayaan melalui komunikasi yang jujur dan praktik bisnis yang beretika.',
    core_value_desc4:
      'Memberikan solusi berkualitas tinggi sekaligus mengoptimalkan sumber daya dan mengurangi limbah.',
    core_value_desc5:
      'Bekerja sama dengan klien, mitra, dan komunitas untuk menciptakan dampak positif.',
    why_join: 'Alasan bergabung di',
    why_join_content_title:
      'Ketika perusahaan mengutamakan karyawan, semua mendapat benefit.',
    why_join_content_desc:
      'Tidak masalah dari mana atau dalam peran apa kamu bergabung. Kamu akan didukung untuk memberikan yang terbaik, menikmati pekerjaan sehari-hari, dan mencapai tujuan yang kamu inginkan.',
    newest: 'Terbaru',
    oldest: 'Terlama',
    applied_jobs: 'Lamaran Pekerjaan',
    candidate_profile: 'Profil Kandidat',
    profile_detail: 'Detail Profil',
    full_name: 'Nama Lengkap',
    name: 'Nama',
    place_of_birth: 'Tempat Lahir',
    date_of_birth: 'Tanggal Lahir',
    date_of_birth_age_range_error:
      'Usia harus antara 16 sampai 55 tahun.',
    marital_status: 'Status Pernikahan',
    religion: 'Agama',
    blood_type: 'Golongan Darah',
    national_id: 'Nomor KTP',
    driver_license_no: 'Nomor SIM',
    weight: 'Berat Badan',
    height: 'Tinggi Badan',
    phone_number: 'Nomor Telepon',
    email_address: 'Alamat Email',
    password: 'Kata Sandi',
    confirm_password: 'Ulangi Kata sandi',
    current_address: 'Alamat Saat Ini',
    next: 'Berikutnya',
    actions: 'Aksi',
    family_structure: 'Struktur Keluarga',
    relation: 'Hubungan',
    gender: 'Jenis Kelamin',
    education: 'Pendidikan',
    occupation: 'Pekerjaan',
    previous: 'Sebelumnya',
    institution: 'Institusi',
    degree: 'Gelar',
    major: 'Jurusan',
    start_date: 'Tanggal Mulai',
    end_date: 'Tanggal Selesai',
    gpa: 'IPK/Nilai rata-rata',
    work_xperience: 'Pengalaman Kerja',
    experience: 'Pengalaman',
    position: 'Posisi',
    company: 'Perusahaan',
    base_salary: 'Gaji Bersih (IDR)',
    job_description: 'Deskripsi Pekerjaan',
    organization: 'Organisasi',
    rejected: 'Ditolak',
    reject_remarks: 'Alasan Penolakan',
    hired: 'Diterima',
    applied: 'Melamar',
    screening: 'Penyaringan',
    assessment: 'Evaluasi',
    psychotest: 'Psikotes',
    interview: 'Wawancara',
    interview_hc: 'Interview HC',
    interview_user: 'Interview User',
    medical_check_up: 'Medical Check Up',
    job_offer: 'Job Offer',
    date: 'Tanggal',
    last_position: 'Posisi Terakhir',
    age: 'Usia',
    certification: 'Sertifikasi',
    certificate_name: 'Nama Sertifikat',
    Credential_uRL: 'URL Kredensial',
    login: 'Masuk',
    profile: 'Profil',
    my_application: 'Lamaran Saya',
    logout: 'Keluar',
    verify: 'Verifikasi',
    resend: 'Kirim Ulang',
    share: 'Bagikan',
    make_your_move: 'Mulai Langkahmu',
    link_coppied: 'Tautan Disalin!',
    full_name_required: 'Nama Lengkap wajib diisi',
    phone_number_required: 'Nomor telepon dengan format yang valid wajib diisi',
    phone_number_format_wrong: 'Format nomor telepon salah',
    please_fill_your_otp: 'Silakan isi OTP!',
    please_verify_your_email: 'Harap verifikasi email Anda!',
    email_required: 'Email wajib diisi',
    cv_required: 'Harap unggah CV Anda',
    uploadFile: 'Upload File (Max. 2MB)',
    invalid_email_format: 'Format email tidak valid',
    please_verify_before_continuing:
      'Verifikasi alamat email sebelum melanjutkan',
    please_select_a_valid_PDF_file: 'Pilih file pdf yang valid',
    file_is_too_large: 'Ukuran file terlalu besar',
    we_sent_otp_to_email: 'Masukkan code OTP yang sudah kami kirimkan ke',
    invalid_otp: 'OTP tidak valid atau kadaluarsa',
    required_error: 'Lengkapi setiap data dengan simbol (*)!',
    skillIsRequired: 'Skill wajib diisi!',
    required_family: 'Data ayah dan Ibu wajib diisi!',
    add_family_member: 'Tambah anggota keluarga',
    no_education: 'Belum ada pendidikan yang ditambahkan',
    no_education_desc:
      'Tambahkan riwayat pendidikan terbaru Anda untuk melengkapi profil.',
    add_edu: 'Tambah Pendidikan',
    required_form: 'Formulir tidak boleh kosong',
    no_organization: 'Belum ada organisasi yang ditambahkan',
    no_organization_desc:
      'Mulailah membangun profil dengan menambahkan organisasi yang pernah Anda ikuti.',
    no_applied_jobs: 'Belum ada pekerjaan yang dilamar',
    no_applied_jobs_desc:
      'Mulai melamar pekerjaan dan selanjutnya akan ditampilkan disini.',
    add_org: 'Tambah Organisasi',
    year: 'Tahun',
    language_proficiency: 'Kemahiran Bahasa Asing',
    no_language: 'Belum ada kemahiran bahasa asing yang ditambahkan',
    no_language_desc:
      'Mulailah membangun profil dengan menambahkan kemahiran bahasa asing Anda',
    add_anguage: 'Tambah Bahasa',
    language: 'Bahasa',
    speaking: 'Berbicara',
    writing: 'Menulis',
    no_work_exp: 'Belum ada pengalaman kerja yang ditambahkan',
    no_work_exp_desc:
      'Tambahkan pengalaman kerja/magang Anda untuk menunjukkan keahlian.',
    add_work_exp: 'Tambah Pengalaman Kerja',
    sector: 'Sektor',
    company_address: 'Alamat Perusahaan',
    leaving_reason: 'Alasan Keluar',
    license_certifcate: 'Lisensi & Sertifikasi',
    add_license: 'Tambah Lisensi & Sertifikasi',
    issuing_org: 'Organisasi Penerbit',
    issue_date: 'Tanggal Terbit',
    expiration_date: 'Tanggal Kedaluwarsa',
    profile_completion: 'Kelengkapan Profil',
    professional_references: 'Referensi Profesional',
    no_references: 'Belum ada referensi yang ditambahkan',
    no_references_desc:
      'Mulai dengan menambahkan supervisor, manager atau rekan kerja sebagai referensi anda.',
    no_license: 'Belum ada lisensi atau sertifikat',
    no_license_desc:
      'Tambahkan lisensi & sertifikat profesional anda untuk menunjukkan kualifikasi dan keahlian anda.',
    no_socmed: 'Belum ada sosial media',
    no_socmed_desc: 'Tambah sosial media untuk melengkapi profilemu.',
    agree_to_contact_references:
      'Dengan melanjutkan proses rekrutmen, saya menyetujui SOPRA Group untuk mengumpulkan, menyimpan, dan memproses data pribadi saya guna keperluan evaluasi lamaran. Saya memahami bahwa Perusahaan dapat memverifikasi referensi dan menggunakan hasil penilaian secara rahasia untuk pengambilan keputusan rekrutmen.',
    no_skill: 'Belum ada skill yang ditambahkan',
    no_skill_desc:
      'Mulai dengan menambahkan skill programming, tools atau skill profesional lainnya.',
    apply_job_success: 'Berhasil melamar pekerjaan!',
    apply_job_failed: 'Gagal Melamar pekerjaan!',
    save_and_next: 'Simpan & Lanjutkan',
    reference: 'Referensi',
    name_of_reference: 'Nama Referensi',
    role_or_position: 'Peran/Posisi',
    contact_references: 'Kontak Referensi',
    relationship: 'Hubungan',
    save: 'Simpan',
    q1: 'Apakah dalam 12 bulan terakhir Anda pernah melamar di PT. Solusi Prima Packaging sebelumnya? Jika "Pernah", jelaskan!',
    q2: 'Apakah Anda mempunyai teman/saudara yang bekerja di PT. Solusi Prima Packaging? Jika "Ya", jelaskan!',
    q3: 'Apakah Anda bersedia bila kami meminta referensi pada perusahaan tempat Anda pernah bekerja?',
    q4: 'Bilamana diterima, bersediakah Anda bekerja dalam sistem shift?',
    q5: 'Bilamana diterima, bersediakah Anda tugas ke luar kota?',
    q6: 'Bilamana diterima, bersediakah Anda ditempatkan di luar kota?',
    q7: 'Pernahkah Anda menderita sakit keras/kronis/kecelakaan berat/operasi? Kalau "Pernah", jelaskan!',
    q8: 'Apakah Anda pernah berurusan dengan kepolisian? Kalau "Pernah", jelaskan!',
    q9: 'Apakah Anda mempunyai gangguan jasmani tetap? Kalau "Ya", jelaskan!',
    q10: 'Apakah Anda memiliki pengalaman bekerja dengan perusahaan sejenis/kompetitor? Kalau "Ya", jelaskan!',
    q11: 'Darimana anda mendapatkan informasi mengenai SOPRA?',
    q12: 'Bilamana diterima, kapan Anda bersedia mulai bekerja?',
    q13: 'Bilamana diterima, berapa remunerasi (All in/THP) yang Anda harapkan?',
    ever: 'Pernah',
    never: 'Tidak Pernah',
    willing: 'Bersedia',
    not_willing: 'Tidak Bersedia',
    choose_availability: 'Pilih Ketersediaan',
    yes: 'Ya',
    no: 'Tidak',
    submit: 'Kirim',
    asap: 'Secepatnya',
    two_weeks: '2 Minggu',
    four_weeks: '4 Minggu',
    eight_weeks: '8 Minggu',
    morethan2month: 'Lebih dari 2 Bulan',
    answer: 'Jawaban',
    family: 'Keluarga',
    add_skills: 'Tambah Skill & Teknologi',
    skills_tech: 'Skill & Technologi',
    skill_name: 'Nama Skill',
    success_to_send: 'Berhasil mengirim formulir',
    date_applied: 'Tanggal Melamar',
    application_progress: 'Progres Lamaran',
    interview_scheduled: 'Interview Dijadwalkan',
    all: 'Semua',
    all_applications: 'Semua Lamaran',
    active_applications: 'Lamaran Aktif',
    history: 'Riwayat',
    interview_mode: 'Mode interview',
    select_interview_time: 'Pilih waktu interview',
    helper_select_interview_time:
      'Silakan pilih jadwal yang sesuai untuk Anda.',
    selected_schedule: 'Terpilih',
    confirm_schedule: 'Konfirmasi Jadwal',
    reschedule: 'Reschedule',
    open_maps: 'Open Maps',
    full_slot: 'Penuh',
    available_slot: 'Tersedia',
    no_active_applications: 'Belum ada lamaran aktif',
    no_active_applications_desc:
      'Jadwal interview Anda akan muncul di sini ketika sudah tersedia.',
    no_history_applications: 'Belum ada riwayat lamaran',
    no_history_applications_desc:
      'Lamaran yang sudah selesai atau diarsipkan akan muncul di sini.',
    interview_deadline_notice:
      'Pilih jadwal sebelum 3 Jun 2025 apabila tidak melakukan pengisian hingga batas waktu tersebut, maka proses akan dianggap gugur.',
    interview_deadline_before: 'Pilih jadwal sebelum',
    interview_deadline_after:
      'apabila tidak melakukan pengisian hingga batas waktu tersebut, maka proses akan dianggap gugur.',
    interview_booking_expires_in: 'Pemilihan jadwal berakhir dalam',
    interview_offline_note: 'Datang langsung ke kantor',
    request_reschedule: 'Ajukan Reschedule',
    request_reschedule_notice:
      'Anda mengajukan reschedule. Pilih jadwal baru dari tanggal yang tersedia di bawah.',
    select_reschedule_date: 'Pilih Tanggal',
    select_reschedule_time: 'Waktu preferensi',
    reschedule_time_helper:
      'Waktu yang ditampilkan adalah waktu yang tersedia untuk dipilih dalam WIB.',
    reschedule_note: 'Alasan reschedule',
    reschedule_note_placeholder: 'Tuliskan alasan atau catatan untuk tim HR...',
    submit_reschedule_request: 'Kirim Permintaan',
    cancel: 'Batal',
    loading: 'Memuat...',
    retry: 'Coba lagi',
    no_data: 'Tidak ada data',
    failed_to_load_data: 'Gagal memuat data',
    failed_to_load_jobs: 'Gagal memuat lowongan',
    loading_applications: 'Memuat lamaran...',
    applications_login_required:
      'Silakan login terlebih dahulu untuk melihat lamaran Anda',
    applications_load_failed: 'Lamaran Anda belum dapat dimuat',
    interview_booking_load_failed:
      'Data penjadwalan interview belum dapat dimuat',
    select_interview_schedule_first:
      'Silakan pilih jadwal interview terlebih dahulu',
    interview_slot_selected_success: 'Jadwal interview berhasil dipilih',
    interview_reschedule_request_success:
      'Permintaan reschedule interview berhasil dikirim',
    interview_reschedule_waiting_title: 'Permintaan reschedule terkirim',
    interview_reschedule_waiting_desc:
      'Permintaan reschedule Anda sudah dikirim. Mohon tunggu update berikutnya dari tim rekrutmen.',
    no_applications_found: 'Belum ada lamaran',
    no_applications_found_desc: 'Anda belum melamar pekerjaan apa pun.',
    no_interview_schedule_available: 'Belum ada jadwal interview',
    no_interview_schedule_available_desc:
      'Saat ini belum ada jadwal interview yang tersedia.',
    interview_schedule: 'Jadwal Interview',
    interview_link: 'Link interview',
    open_link: 'Buka Link',
    slot_left: 'slot tersisa',
    no_interview_slots_available:
      'Belum ada slot interview yang tersedia untuk tanggal ini.',
    book_interview: 'Jadwalkan Interview',
    book_interview_hc: 'Jadwalkan Interview HC',
    book_interview_user: 'Jadwalkan Interview User',
    interview_schedule_available_desc:
      'Anda sudah bisa memilih jadwal interview sendiri.',
    interview_invitation_expired_title: 'Undangan interview sudah kedaluwarsa',
    interview_invitation_waiting_title: 'Undangan interview sedang disiapkan',
    interview_invitation_waiting_desc:
      'Undangan interview Anda sedang disiapkan. Mohon tunggu update berikutnya dari tim rekrutmen.',
    interview_invitation_expired_desc:
      'Batas waktu pemilihan jadwal interview Anda sudah berakhir. Mohon tunggu update berikutnya dari tim rekrutmen.',
    interview_invitation_used_title: 'Undangan interview tidak tersedia',
    interview_invitation_used_desc:
      'Link undangan interview ini sudah pernah digunakan. Mohon tunggu update berikutnya dari tim rekrutmen.',
    preferred_date: 'Tanggal pilihan',
    interview_hc_schedule: 'Jadwal Interview HC',
    interview_user_schedule: 'Jadwal Interview User',
    interview_selected_notice_before: 'Jadwal interview Anda pada',
    interview_selected_notice_at: 'pukul',
    interview_selected_notice_after:
      'telah dipilih. Silakan menunggu update selanjutnya.',
    offer_confirmation: 'Konfirmasi Penawaran',
    agreed_take_home: 'Take-home yang disepakati',
    basic_salary: 'Gaji pokok',
    transport_allowance: 'Tunjangan transport',
    meal_allowance: 'Tunjangan makan',
    health_insurance_bpjs: 'Asuransi kesehatan (BPJS)',
    covered_by_company: 'Ditanggung perusahaan',
    probation_period: 'Masa percobaan',
    job_offer_probation_end_evaluation: '(evaluasi di akhir)',
    job_offer_probation_period_value:
      '3 bulan (evaluasi di akhir masa percobaan)',
    job_offer_confidentiality_notice:
      'Informasi ini bersifat rahasia. Dokumen ini tidak boleh diunduh, dicetak, atau dibagikan.',
    job_offer_start_date_note:
      'Saya berkomitmen untuk hadir pada tanggal yang saya pilih.',
    commitment_statement: 'Pernyataan komitmen',
    agree_commitment_statement: 'Saya menyetujui pernyataan komitmen di atas',
    required: 'Wajib',
    confirm: 'Konfirmasi',
    full_time: 'Penuh Waktu',
    job_offer_commitment_item_1:
      'Saya telah membaca dan memahami seluruh detail job offer ini.',
    job_offer_commitment_item_2:
      'Saya menyetujui paket kompensasi, lokasi kerja, dan tanggal mulai yang disepakati.',
    job_offer_commitment_item_3:
      'Saya berkomitmen untuk hadir pada tanggal yang dipilih.',
    job_offer_commitment_item_4:
      'Saya memahami bahwa informasi ini bersifat rahasia dan tidak akan saya sebarkan.',
    job_offer_confirmation_pending_title: 'Konfirmasi belum terhubung',
    job_offer_confirmation_pending_desc:
      'Konfirmasi job offer ini saat ini masih berupa slicing frontend dan akan disambungkan ke API nanti.',
    job_offer_positional_allowance: 'Tunjangan jabatan',
    job_offer_operational_allowance: 'Tunjangan operasional',
    total_salary_received: 'Total gaji diterima',
    job_offer_waiting_desc:
      'Detail job offer Anda masih sedang disiapkan. Mohon tunggu update berikutnya dari tim rekrutmen.',
    medical_check_up_notice_prefix:
      'Dokumen Anda telah kami terima. Mohon pantau ',
    medical_check_up_notice_email_bold:
      'email Anda untuk informasi lebih lanjut',
    medical_check_up_notice_middle:
      ' dari tim HR kami dan jangan lupa cek folder ',
    medical_check_up_notice_spam_bold: 'Spam',
    medical_check_up_notice_suffix: ' juga.',
    job_offer_expired_title: 'Job offer sudah kedaluwarsa',
    job_offer_expired_desc:
      'Batas waktu konfirmasi job offer ini sudah berakhir. Mohon tunggu update berikutnya dari tim rekrutmen.',
    job_offer_otp_pending_desc:
      'Masukkan kode OTP untuk melanjutkan ke tahap dokumen pre-onboarding.',
    job_offer_confirm_before_desc:
      'Silakan konfirmasi job offer ini sebelum batas waktu berakhir agar bisa lanjut ke tahap verifikasi OTP.',
    job_offer_deadline_title: 'Penawaran berakhir dalam',
    job_offer_otp_deadline_title: 'OTP berakhir',
    job_offer_expiry_label: 'Kedaluwarsa',
    job_offer_confirm_validation:
      'Silakan pilih tanggal mulai dan setujui pernyataan komitmen terlebih dahulu.',
    job_offer_otp_generated_title: 'OTP berhasil dibuat',
    job_offer_otp_generated_desc:
      'Kode OTP berhasil disimpan. Anda bisa lanjut verifikasi setelah mendapatkan kode tersebut.',
    job_offer_otp_required: 'Silakan masukkan kode OTP terlebih dahulu.',
    job_offer_otp_verified_title: 'OTP berhasil diverifikasi',
    job_offer_otp_verified_desc:
      'Anda dapat melanjutkan untuk mengisi dokumen pre-onboarding.',
    job_offer_otp_title: 'Verifikasi OTP',
    job_offer_otp_manual_desc:
      'Pengiriman OTP via email masih ditunda. Untuk sementara, gunakan kode OTP yang tersimpan di backend secara manual.',
    job_offer_request_otp_wait: 'Mohon tunggu sebelum meminta OTP lagi',
    second_abbrev: 'd',
    job_offer_identity_verification_title: 'Verifikasi Identitas',
    job_offer_otp_sent_to: 'Kode OTP 6 digit telah dikirim ke',
    job_offer_signature_title: 'Tanda tangan persetujuan penawaran kerja',
    job_offer_signature_desc:
      'Masukkan kode OTP untuk menyelesaikan persetujuan Anda. Kode ini berfungsi sebagai tanda tangan digital untuk penawaran kerja ini.',
    job_offer_resend_prompt: 'Tidak menerima kode?',
    job_offer_resend_otp: 'Kirim ulang',
    job_offer_generate_otp_again: 'Buat Ulang OTP',
    otp_code: 'Kode OTP',
    input_otp: 'Masukkan OTP',
    verify_otp: 'Verifikasi OTP',
    error_title: 'Kesalahan!',
    uploading: 'Mengunggah...',
    month: 'bulan',
    other_benefit: 'Benefit lainnya',
    pre_onboarding_checklist: 'Checklist Pra-Onboarding',
    pre_onboarding_subtitle:
      'Unggah seluruh dokumen wajib untuk memulai proses onboarding.',
    document_fill_expires_in: 'Pengisian dokumen berakhir dalam',
    expires: 'Berakhir',
    optional: 'Opsional',
    choose_file: 'Pilih File',
    upload_prompt_click_or_drag: 'Klik untuk upload atau drag & drop',
    upload_prompt_drop_or_click: 'Letakkan file di sini atau klik untuk upload',
    upload_support_formats: 'Mendukung file JPG, JPEG, PNG & PDF hingga 2MB',
    ktp: 'Kartu Tanda Penduduk - KTP',
    ktp_number: 'Nomor KTP',
    input_ktp: 'Input KTP',
    ktp_upload_desc:
      'Unggah foto atau scan Kartu Tanda Penduduk yang masih berlaku.',
    kk: 'Kartu Keluarga - KK',
    kk_number: 'Nomor KK',
    input_kk: 'Masukkan Nomor KK',
    kk_upload_desc: 'Unggah foto atau scan Kartu Keluarga Anda.',
    npwp: 'Nomor Pokok Wajib Pajak - NPWP',
    npwp_number: 'Nomor NPWP',
    input_npwp: 'Input NPWP',
    npwp_upload_desc: 'Unggah foto atau scan kartu NPWP Anda.',
    bank_account_details: 'Detail Rekening Bank',
    bank_account_upload_desc:
      'Masukkan detail rekening BCA Anda untuk proses payroll.',
    bank_name: 'Nama Bank',
    input_bank_name: 'Khusus BCA',
    account_number: 'Nomor Rekening',
    input_account_number: 'Input Nomor',
    account_holder_name: 'Nama Pemilik Rekening',
    input_account_holder_name: 'Sesuai buku tabungan',
    bank_book_upload_note:
      'Atau unggah foto halaman pertama buku tabungan Anda:',
    emergency_contact: 'Kontak Darurat',
    emergency_contact_desc:
      'Masukkan nama, hubungan, dan nomor telepon kontak darurat Anda.',
    emergency_contact_name_placeholder: 'Nama kontak darurat',
    emergency_contact_phone_placeholder: '+62 8XX XXXX XXXX',
    emergency_contact_relationship_placeholder: 'cth. Orang Tua, Pasangan',
    bpjs_kesehatan_ketenagakerjaan: 'BPJS Kesehatan & Ketenagakerjaan',
    bpjs_upload_desc:
      'Unggah kartu BPJS Anda jika sudah memiliki. Opsional jika belum terdaftar.',
    bpjs_kesehatan: 'BPJS Kesehatan',
    bpjs_ketenagakerjaan: 'BPJS Ketenagakerjaan',
    pre_onboarding_declaration_heading: 'Pernyataan deklarasi',
    pre_onboarding_declaration_title:
      'Dengan mengirimkan data ini, saya menyatakan bahwa:',
    pre_onboarding_declaration_item_1:
      'Semua informasi dan dokumen yang saya berikan adalah benar dan valid.',
    pre_onboarding_declaration_item_2:
      'Saya bersedia menerima konsekuensi apabila ada data yang terbukti tidak akurat.',
    pre_onboarding_declaration_item_3:
      'Data ini akan digunakan untuk proses onboarding oleh tim HR.',
    pre_onboarding_agree_declaration_statement:
      'Saya menyetujui pernyataan deklarasi di atas',
    pre_onboarding_ktp_required: 'Nomor KTP wajib diisi.',
    pre_onboarding_ktp_invalid: 'Nomor KTP harus terdiri dari tepat 16 digit.',
    pre_onboarding_kk_required: 'Nomor KK wajib diisi.',
    pre_onboarding_kk_invalid: 'Nomor KK harus terdiri dari tepat 16 digit.',
    pre_onboarding_npwp_required: 'Nomor NPWP wajib diisi.',
    pre_onboarding_npwp_invalid:
      'Nomor NPWP harus terdiri dari tepat 15 digit.',
    pre_onboarding_bank_name_required: 'Nama bank wajib diisi.',
    pre_onboarding_bank_name_invalid: 'Masukkan nama bank yang valid.',
    pre_onboarding_account_number_required: 'Nomor rekening wajib diisi.',
    pre_onboarding_account_number_invalid:
      'Nomor rekening harus terdiri dari 8 sampai 20 digit.',
    pre_onboarding_account_holder_name_required:
      'Nama pemilik rekening wajib diisi.',
    pre_onboarding_account_holder_name_invalid:
      'Masukkan nama pemilik rekening yang valid.',
    pre_onboarding_emergency_contact_name_required:
      'Nama kontak darurat wajib diisi.',
    pre_onboarding_emergency_contact_name_invalid:
      'Masukkan nama kontak darurat yang valid.',
    pre_onboarding_emergency_contact_phone_required:
      'Nomor telepon kontak darurat wajib diisi.',
    pre_onboarding_emergency_contact_phone_invalid:
      'Masukkan nomor telepon yang valid.',
    pre_onboarding_relationship_required: 'Hubungan wajib diisi.',
    pre_onboarding_relationship_invalid: 'Masukkan hubungan yang valid.',
    pre_onboarding_file_required: 'Silakan unggah dokumen ini.',
    pre_onboarding_file_invalid:
      'Hanya file JPG, JPEG, PNG, atau PDF yang diperbolehkan.',
    pre_onboarding_file_too_large: 'Ukuran file maksimal 2MB.',
    pre_onboarding_file_upload_failed:
      'Gagal mengunggah file yang dipilih. Silakan coba lagi.',
    pre_onboarding_declaration_required:
      'Silakan centang pernyataan sebelum mengirim.',
    pre_onboarding_submitted_title: 'Pre-onboarding berhasil dikirim',
    pre_onboarding_submitted_desc:
      'Dokumen pre-onboarding Anda sudah berhasil dikirim. Mohon tunggu update berikutnya dari tim HR.',
    pre_onboarding_expired_title: 'Pre-onboarding sudah kedaluwarsa',
    pre_onboarding_expired_desc:
      'Batas waktu pengumpulan dokumen ini sudah berakhir. Mohon tunggu update berikutnya dari tim HR.',
    pre_onboarding_submit_success: 'Pre-onboarding berhasil dikirim.',
    submitted: 'Terkirim',
    general_questions: 'Pertanyaan Umum',
    select_source: 'Pilih Sumber',
    other: 'Lainnya',
    emailregistered: 'Email telah terdaftar',
    already_have_an_account: 'Sudah punya akun?',
    dont_have_an_account: 'Tidak punya akun?',
    password_required: 'Kata sandi wajib diisi',
    password_length: 'Kata sandi minimum 6 karakter',
    password_not_match: 'Kata sandi tidak cocok',
    profile_not_complete: 'Profile belum lengkap!',
    session_expired: 'Sesi berakhir, silahkan login untuk melanjutkan!',
    forget_password: 'Lupa kata sandi',
    register_info: 'Kamu harus memiliki akun untuk melanjutkan lamaran ini!',
    login_required_title: 'Login Diperlukan',
    please_login: 'Silakan Login',
    sign_in_desc: 'Masuk untuk melanjutkan',
    login_to_apply_desc: 'Silakan login terlebih dahulu untuk melanjutkan lamaran Anda',
    hello: 'Halo',
    temp_password_change_desc: 'silakan ganti kata sandi Anda untuk melanjutkan.',
    forget_password_desc: 'Verifikasi email untuk melanjutkan',
    remember_me: 'Ingat saya',
    register: 'Buat Akun',
    new_password: 'Kata Sandi Baru',
    register_to_proceed: 'Daftar Akun untuk Melanjutkan',
    change_password: 'Ubah Kata Sandi',
    back: 'Kembali',
    register_success: 'Berhasil daftar akun',
    change_password_success: 'Berhasil ubah kata sandi',
    set_password: 'Buat kata sandi akun anda',
    set_new_password: 'Buat kata sandi baru anda',
    invalid_link: 'Link tidak valid',
    enter_email: 'Masukkan email',
    enter_password: 'Masukkan kata sandi',
    enter_new_password: 'Masukkan kata sandi baru',
    confirm_new_password: 'Konfirmasi kata sandi baru',
    enter_name: 'Masukkan nama anda',
    enter_phone_number: 'Masukkan nomor telepon',
    sign_up: 'Daftar',
    continue: 'Lanjutkan',
    warning: 'Warning',
    information: 'Informasi',
    work_exp_subtitle:
      'Tambahkan pengalaman kerja/magang Anda untuk menunjukkan keahlian',
    edu_subtitle: 'Pendidikan terakhir akan otomatis berada di urutan pertama.',
    org_subtitle: 'Organisasi terakhir akan otomatis berada di urutan pertama.',
    pref_subtitle:
      'Referensi Profesional terakhir akan otomatis berada di urutan pertama.',
    complete_before: 'Selesaikan sebelum',
    pre_assessment_expires_in: 'Pre assessment berakhir dalam',
    assessment_expires_in: 'Assessment berakhir dalam',
    pretest_screening_desc:
      'Pre assessment Anda sudah tersedia. Silakan selesaikan untuk lanjut ke tahap berikutnya.',
    pretest_finished_title: 'Pre Assessment Selesai!',
    pretest_finished_desc:
      'Terima kasih telah menyelesaikan pre assessment. Jawaban Anda telah berhasil tersimpan dan terkirim.',
    pretest_finished_hint: 'Anda dapat menutup halaman ini.',
    pretest_already_completed_title: 'Anda sudah mengerjakan pre assessment',
    pretest_already_completed_desc:
      'Pre assessment Anda sudah pernah dikirim. Silakan tunggu update berikutnya dari tim rekrutmen.',
    pretest_already_completed_hint:
      'Silakan tunggu update berikutnya dari tim rekrutmen.',
    pretest_expired_title: 'Waktu pengerjaan pre assessment sudah selesai',
    pretest_expired_desc:
      'Batas waktu untuk mengerjakan pre assessment Anda sudah berakhir. Mohon tunggu update berikutnya dari tim rekrutmen.',
    pretest_card_title: 'Pre Assessment',
    pretest_card_desc:
      'Jawab setiap pertanyaan dengan jujur dan submit sebelum waktu habis.',
    pretest_portal_note:
      'Setelah menyelesaikan pre assessment, Anda dapat memantau perkembangan proses rekrutmen melalui portal job',
    open_pretest: 'Buka Pre Assessment',
    open_assessment: 'Buka Assessment',
    open_psychotest: 'Buka Psikotes',
    internet_error_title: 'Kesalahan Jaringan!',
    internet_error: 'Periksa koneksi internet, dan coba lagi!',
    proceed: 'Lanjutkan',
    checkNoExperience:
      'Silahkan tandai pernyataan dibawah, jika Anda tidak memiliki pengalaman kerja!',
    noExperience: 'Saya tidak memiliki pengalaman kerja',
    isMyCurrentJob: 'Masih Bekerja',
    total_beginner: 'Tidak menguasai',
    active: 'Aktif',
    passive: 'Passive',
    advanceLevel: 'Level Lanjutan/Ahli',
    intermediateLevel: 'Level Menengah',
    beginnerLevel: 'Level Pemula',
    advanced: 'Lanjutan/Ahli',
    intermediate: 'Menengah',
    beginner: 'Pemula',
    haveJobExp: 'Saya memiliki pengalaman kerja',
    haveNoJobExp: 'Saya belum memiliki pengalaman kerja',
    chooseWorkExpStatus: 'Pilih status pengalaman pekerjaan anda!',
    inputWorkExp: 'Silahkan isi pengalaman kerja anda!',
    raising_star: 'Raising STAR',
    raising_title:
      'SOPRA Raising Talent dirancang untuk memberdayakan talenta masa depan melalui kemitraan pendidikan yang strategis dan berkelanjutan dalam jangka panjang, sehingga membangun ekosistem pencarian talenta yang berkesinambungan dan terintegrasi dengan strategi rekrutmen SOPRA.',
    goals: 'Tujuan',
    goals1_title: 'Kemitraan Strategis dengan Dunia Pendidikan',
    goals2_title: 'Pengembangan Talenta Siap Industri',
    goals1_description:
      'Membangun kerja sama jangka panjang dengan institusi pendidikan yang selaras dengan kebutuhan industri.',
    goals2_description:
      'Membekali siswa dan mahasiswa dengan kompetensi, pola pikir, serta kesiapan yang dibutuhkan untuk memasuki dunia profesional.',
    highlights2_description:
      'Membekali generasi muda dengan wawasan dan kepercayaan diri untuk menghadapi proses rekrutmen di dunia kerja saat ini.',
    highlights1_description:
      'Kesempatan karier eksklusif yang khusus diperuntukkan bagi siswa, mahasiswa, dan alumni dari institusi pendidikan mitra.',
    job_fair_description:
      'SOPRA Group secara aktif berpartisipasi dalam berbagai job fair dan career events untuk terhubung dengan para profesional masa depan. Melalui acara ini, Anda dapat mengenal SOPRA lebih dekat, mulai dari budaya kerja, jalur karier, hingga berbagai peluang yang tersedia di seluruh unit bisnis kami.',
  },
}

const Lang = (code, word) => {
  const res = langData[code] || langData.en
  return res[word] || langData.en[word] || ''
}

export default Lang
